var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsanaOutlined = function SvgAsanaOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M446.72 151.637a170.667 170.667 0 1 1 130.56 315.35A170.667 170.667 0 0 1 446.72 151.68zm65.28 51.03A106.667 106.667 0 1 0 512 416a106.667 106.667 0 0 0 0-213.333M233.387 535.68a170.667 170.667 0 1 1 130.602 315.35 170.667 170.667 0 0 1-130.645-315.393zm65.28 50.987a106.667 106.667 0 1 0 0 213.376 106.667 106.667 0 0 0 0-213.376m426.666-64a170.667 170.667 0 1 0 0 341.333 170.667 170.667 0 0 0 0-341.333m-40.832 72.106a106.667 106.667 0 1 1 81.664 197.12 106.667 106.667 0 0 1-81.664-197.12"
  })));
};
export default SvgAsanaOutlined;